<header id="header-container-ex">
  @if (!this.no_logo) {
    <div class="wrap-img" (click)="goTo('home')">
      <img class="header-img" src="../../../assets/img/Costa.png" alt="">
    </div>
  }
</header>
